import { Outlet, createFileRoute } from '@tanstack/react-router'
import { CircleX } from 'lucide-react'

import { getSpaceByIdOptions } from '@/api/codegen/@tanstack/react-query.gen'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/Alert'

const isNotAuthorizedError = (error: unknown): boolean =>
  !!error &&
  typeof error === 'object' &&
  'code' in error &&
  (error as { code: string }).code === 'USER_NOT_AUTHORIZED'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/settings',
)({
  component: () => <Outlet />,
  errorComponent: ({ error }) => {
    if (!isNotAuthorizedError(error)) {
      throw error
    }

    return (
      <Alert variant="destructive" className="m-4 w-auto">
        <CircleX />
        <AlertTitle>Heads up!</AlertTitle>
        <AlertDescription>
          You are not authorized to access this space.
        </AlertDescription>
      </Alert>
    )
  },
  loader: async ({
    context: { queryClient },
    params: { spaceId, companyId },
  }) => {
    await queryClient.ensureQueryData(
      getSpaceByIdOptions({
        path: { companyID: companyId, spaceID: spaceId },
      }),
    )
  },
})
